import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@bingads-webui-react/primitive';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getDefaultModalStyle } from '../styles/common-styles';

export const AlertDialog = ({
  name,
  onAction,
  title,
  content,
  alertButtonText,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getDefaultModalStyle);

  return (
    <Modal show backdrop="static" className={`${name}-alert-dialog`} onHide={onAction} dialogClassName={classes.modalWidth}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`${name}-alert-dialog-content`}>
        <p>
          {content}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="action-button" btnStyle="primary" onClick={onAction}>
          {alertButtonText || i18n.getString(_TL_('OK'))}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AlertDialog.propTypes = {
  name: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  alertButtonText: PropTypes.string,
};

AlertDialog.defaultProps = {
  alertButtonText: null,
};
